import { render, staticRenderFns } from "./RealEstateSigns.vue?vue&type=template&id=079ddcfc&scoped=true&"
import script from "./RealEstateSigns.vue?vue&type=script&lang=ts&"
export * from "./RealEstateSigns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079ddcfc",
  null
  
)

export default component.exports